import React, { createContext, useContext, useState } from "react";

import NewHeader from "../../components/layout/NewHeader";
import Modal from "../../components/layout/modal";

import { Route, Switch } from "wouter";
import { useViewData } from "./useViewData";
import { LoginForm } from "./loginForm";
import { SendCodeForm, UpdateFormForm, ValidateCodeForm } from "./recoveryForms";

const mainSpinner: React.CSSProperties & Record<string, string> = {
    '--size': '40px',
    '--color': '#103EFF',
    '--width': '5px',
    margin: 'auto'
};

export default function () {
    const { view: { data, isLoading } } = useViewData();
    const [recoveryStep, setRecoveryStep] = useState(1);

    const wrapperStyle: React.CSSProperties & Record<string, string | number> = {
        '--bg-color-title': data?.bgs?.bgcolor1,
        '--bg-color': data?.bgs?.bgcolor2,
        position: 'relative',
        zIndex: 9999
    }

    if (isLoading) {
        return (
            <div className="ar__wrapper_v2" style={wrapperStyle}>
                <main className="ar__login_v2 ar__body_v2">
                    <div className="ar__login_v2__container">
                        <div className="spinner" style={mainSpinner}></div>
                    </div>
                </main>
            </div>
        )
    }

    return (
        <div className="ar__wrapper_v2" style={wrapperStyle}>
            <span className="ar__wrapper_v2__header"></span>
            <NewHeader showButtons={false} logo={data?.bgs?.logo?.url} />
            <Modal />
            <main className="ar__login_v2 ar__body_v2">

                {/* BACKGROUND IMAGE */}
                {
                    (data.bgs?.bg?.url || data.bgs?.bgm?.url)
                    && (
                        <picture>
                            <source media="(min-width: 991px)" srcSet={data.bgs.bg.url} />
                            <img src={data.bgs.bgm.url || data.bgs.bg.url} alt="" className="ar__login_v2__bg ar__login_v2_fade" />
                        </picture>
                    )
                }

                {/* FLOAT IMAGES */}
                {data.bgs?.bgleft?.url && <img className="ar__login_v2__left" src={data.bgs.bgleft.url} alt="" title="" />}
                {data.bgs?.bgright?.url && <img className="ar__login_v2__right" src={data.bgs.bgright.url} alt="" title="" />}

                {/* MAIN CONTENT */}
                <div className="ar__login_v2__container ar__login_v2_fade" onAnimationEnd={(e) => {
                    (e.target as HTMLElement).classList.remove('ar__login_v2_fade')
                }}>
                    <Switch>
                        <Route path='/estadio-aguila/registro'>
                            <LoginForm data={data} />
                        </Route>
                        <Route path='/estadio-aguila/iniciar-sesion'>
                            <LoginForm data={data} />
                        </Route>
                        <Route path='/estadio-aguila/recuperar-contrasena'>
                            <RecoveryProvider>
                                {
                                    recoveryStep === 1
                                        ? <SendCodeForm data={data.reset?.step1} onValid={() => setRecoveryStep(2)} />
                                        : recoveryStep === 2
                                            ? <ValidateCodeForm data={data.reset?.step2} onValid={() => setRecoveryStep(3)} onBack={() => setRecoveryStep(1)} />
                                            : <UpdateFormForm data={{ ...data.reset?.step3, popup: data.pasos?.paso3?.popup }} onValid={() => setRecoveryStep(1)} />
                                }
                            </RecoveryProvider>
                        </Route>
                    </Switch>
                </div>
            </main>
        </div>
    )
}

//* EMAIL OR PHONE CONTEXT
const INITIALIZE = { recoverySession: { emailOrPhone: '', token: '', value: '' }, setRecoverySession: (p: SessionInterface) => { } };

const RecoveryContext = createContext<{ recoverySession: SessionInterface, setRecoverySession: (p: SessionInterface) => void }>(INITIALIZE);
const RecoveryProvider = ({ children }: { children: React.ReactNode }) => {
    const [recoverySession, setRecoverySession] = useState<SessionInterface>({
        emailOrPhone: '',
        token: '',
        value: ''
    });

    return (
        <RecoveryContext.Provider value={{ recoverySession, setRecoverySession }}>
            {children}
        </RecoveryContext.Provider>
    )
}

export const useRecovery = () => {
    const context = useContext(RecoveryContext);
    if (!context) return INITIALIZE;
    return context;
}

interface SessionInterface {
    emailOrPhone: string | number;
    token: string;
    value: string
}